import { Component, OnInit, Inject } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, DateAdapter } from '@angular/material';
import { AdminToursService } from '../shared/service/admin-tours.service';
import { environment } from 'src/environments/environment';
import { Review } from '../shared/model/Review';
import { WriteReviewService } from '../shared/service/write-review.service';
import { CommonService } from '../shared/service/common.service';
import { StarRatingComponent } from 'ng-starrating';

@Component({
  selector: 'app-tours-details',
  templateUrl: './tours-details.component.html',
  styleUrls: ['./tours-details.component.css']
})
export class ToursDetailsComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  tourId: number;
  toursArr = [];
  tourPriceArr = [];
  tourPerCoupleArr = [];
  tourPerPersonArr = [];
  flightPriceArr = [];
  imagePath: string;
  Month1 = '';
  Date1 = '';
  Month2 = '';
  Date2 = '';
  Month3 = '';
  Date3 = '';
  Month4 = '';
  Date4 = '';
  Month5 = '';
  Date5 = '';
  Month6 = '';
  Date6 = '';
  Month7 = '';
  Date7 = '';
  Month8 = '';
  Date8 = '';
  reviewArr: Review[] = [];
  imageBaseUrl: string = environment.imageBaseUrl;
  serviceBaseUrl: string = environment.serviceBaseUrl;
  constructor(private route: ActivatedRoute, private dialog: MatDialog, private adminToursService: AdminToursService, private commonService: CommonService, private writeReviewService: WriteReviewService) {
    this.route.params.subscribe((result) => {
      this.tourId = result.id;
    }, (err) => console.log(err));
  }


  ngOnInit() {
    this.getToursById();
    this.imagePath = this.imageBaseUrl + "/tours-img/KesaviDefault.jpg";
    // console.log("this.toursArr", this.toursArr);
  }

  getToursById() {
    this.adminToursService
      .getToursByID(this.tourId)
      .then((result) => {
        this.toursArr = result;
        this.commonService.selectedTourId = result[0].Id;
        this.commonService.selectedName = result[0].TourName;
        this.grtReviewByTourId(this.commonService.selectedTourId);
        console.log("result", result);
        if (this.toursArr[0].TourPrice) {
          this.tourPriceArr = this.toursArr[0].TourPrice.split(',');
        }

        if(this.toursArr[0].FlightPrice){
          this.flightPriceArr = this.toursArr[0].FlightPrice.split(',');
        }

        for (let i = 0; i < this.tourPriceArr.length; i++) {
          if (i <= 3) {
            this.tourPerCoupleArr.push(this.tourPriceArr[i]);
          }
          else {
            this.tourPerPersonArr.push(this.tourPriceArr[i]);
          }
        }
        if (this.toursArr[0].TourDates) {
          let tourDateArr = this.toursArr[0].TourDates.split(';');
          let tmpDatesArr1 = tourDateArr[0].split('=');
          if (tmpDatesArr1[0] != "undefined") {
            this.Month1 = tmpDatesArr1[0];
            let tmpDatesArr1Child = tmpDatesArr1[1].split("R");
            if (tmpDatesArr1Child[0] != "undefined")
              this.Date1 = tmpDatesArr1Child[0];
            if (tmpDatesArr1Child[1] != "undefined")
              this.Date1 += "," + tmpDatesArr1Child[1];
          }

          if (tourDateArr[1]) {
            let tmpDatesArr2 = tourDateArr[1].split('=');
            if (tmpDatesArr2[0] != "undefined") {
              this.Month2 = tmpDatesArr2[0];
              if (tmpDatesArr2[1]) {
                let tmpDatesArr2Child = tmpDatesArr2[1].split("R");
                if (tmpDatesArr2Child[0] != "undefined")
                  this.Date2 = tmpDatesArr2Child[0];
                if (tmpDatesArr2Child[1] != "undefined")
                  this.Date2 += "," + tmpDatesArr2Child[1];
              }
            }
          }

          if (tourDateArr[2]) {
            let tmpDatesArr3 = tourDateArr[2].split('=');
            if (tmpDatesArr3[0] != "undefined") {
              this.Month3 = tmpDatesArr3[0];
              if (tmpDatesArr3[1]) {
                let tmpDatesArr3Child = tmpDatesArr3[1].split("R");
                if (tmpDatesArr3Child[0] != "undefined")
                  this.Date3 = tmpDatesArr3Child[0];
                if (tmpDatesArr3Child[1])
                  this.Date3 += "," + tmpDatesArr3Child[1];
                  // console.log(tmpDatesArr3Child[1]);
              }
            }
          }

          if (tourDateArr[3]) {
            let tmpDatesArr4 = tourDateArr[3].split('=');
            if (tmpDatesArr4[0] != "undefined") {
              this.Month4 = tmpDatesArr4[0];
              if (tmpDatesArr4[1]) {
                let tmpDatesArr4Child = tmpDatesArr4[1].split("R");
                if (tmpDatesArr4Child[0] != "undefined")
                  this.Date4 = tmpDatesArr4Child[0];
                if (tmpDatesArr4Child[1] != "undefined")
                  this.Date4 += "," + tmpDatesArr4Child[1];
              }
            }
          }

          if (tourDateArr[4]) {
            let tmpDatesArr4 = tourDateArr[4].split('=');
            if (tmpDatesArr4[0] != "undefined") {
              this.Month4 = tmpDatesArr4[0];
              if (tmpDatesArr4[1]) {
                let tmpDatesArr4Child = tmpDatesArr4[1].split("R");
                if (tmpDatesArr4Child[0] != "undefined")
                  this.Date4 = tmpDatesArr4Child[0];
                if (tmpDatesArr4Child[1] != "undefined")
                  this.Date4 += "," + tmpDatesArr4Child[1];
              }
            }
          }

          if (tourDateArr[5]) {
            let tmpDatesArr4 = tourDateArr[5].split('=');
            if (tmpDatesArr4[0] != "undefined") {
              this.Month5 = tmpDatesArr4[0];
              if (tmpDatesArr4[1]) {
                let tmpDatesArr4Child = tmpDatesArr4[1].split("R");
                if (tmpDatesArr4Child[0] != "undefined")
                  this.Date5 = tmpDatesArr4Child[0];
                if (tmpDatesArr4Child[1] != "undefined")
                  this.Date5 += "," + tmpDatesArr4Child[1];
              }
            }
          }

          if (tourDateArr[6]) {
            let tmpDatesArr4 = tourDateArr[6].split('=');
            if (tmpDatesArr4[0] != "undefined") {
              this.Month6 = tmpDatesArr4[0];
              if (tmpDatesArr4[1]) {
                let tmpDatesArr4Child = tmpDatesArr4[1].split("R");
                if (tmpDatesArr4Child[0] != "undefined")
                  this.Date6 = tmpDatesArr4Child[0];
                if (tmpDatesArr4Child[1] != "undefined")
                  this.Date6 += "," + tmpDatesArr4Child[1];
              }
            }
          }

          if (tourDateArr[7]) {
            let tmpDatesArr4 = tourDateArr[7].split('=');
            if (tmpDatesArr4[0] != "undefined") {
              this.Month7 = tmpDatesArr4[0];
              if (tmpDatesArr4[1]) {
                let tmpDatesArr4Child = tmpDatesArr4[1].split("R");
                if (tmpDatesArr4Child[0] != "undefined")
                  this.Date7 = tmpDatesArr4Child[0];
                if (tmpDatesArr4Child[1] != "undefined")
                  this.Date7 += "," + tmpDatesArr4Child[1];
              }
            }
          }
        }
      })
      .catch((err) => console.log(err));
  }

  grtReviewByTourId(id: number) {
    this.blockUI.start('Please wait...');
    this.writeReviewService
      .getReviewByTour(this.tourId)
      .then((result) => {
        this.reviewArr = result;
        console.log(this.reviewArr);
        setTimeout(() => {
          this.blockUI.stop();
        }, 500);
      })
      .catch((err) => console.log(err));
  }

  DownloadTourPDF() {
    if (this.toursArr[0].PDFFile) {
      // var filePath = '../../assets/pdf/' + this.toursArr[0].PDFFile;
      var filePath = this.serviceBaseUrl + '/Resources/PDF/Tours/' + this.toursArr[0].Id + "/" + this.toursArr[0].PDFFile;
      var fileName = filePath.split('/');
      if (this.toursArr[0].PDFFile == fileName[fileName.length - 1]) {
        window.open(filePath, "_blank");
      }
    }
  }

  writeReview() {
    const dialogRef = this.dialog.open(WriteReviewDialog, {
      width: '1000px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("Review: ", result);
      if (result && result.Name) {
        this.reviewArr.push(result);
      }
    });
  }

}

// Dialoag Component

@Component({
  selector: 'write-review-dialog',
  templateUrl: 'write-review-dialog.html',
})
export class WriteReviewDialog {
  @BlockUI() blockUI: NgBlockUI;
  isUpdate: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<WriteReviewDialog>,
    @Inject(MAT_DIALOG_DATA) public data: Review, private writeReviewService: WriteReviewService, private commonService: CommonService) {
    if (this.data.Id) {
      this.isUpdate = true;
    }
    else {
      this.isUpdate = false;
    }
  }

  onRate($event: { oldValue: number, newValue: number, starRating: StarRatingComponent }) {
    // alert(`Old Value:${$event.oldValue}, 
    //   New Value: ${$event.newValue}, 
    //   Checked Color: ${$event.starRating.checkedcolor}, 
    //   Unchecked Color: ${$event.starRating.uncheckedcolor}`);
    this.data.RateValue = $event.newValue;
  }

  addReview() {
    // this.data.Id = this.getGUID(); //Add id
    this.blockUI.start('Please wait...');
    console.log("this.commonService.selectedTourId", this.commonService.selectedTourId);
    this.data.TourId = this.commonService.selectedTourId;
    this.data.TourName = this.commonService.selectedName;
    this.data.ReviewDate = new Date().toUTCString();
    console.log("data", this.data);
    this.writeReviewService
      .addReview(this.data)
      .then((result) => {
        this.clearControl();
        this.blockUI.stop();
        this.dialogRef.close(this.data);
        setTimeout(() => {
          this.blockUI.stop();
        }, 500);
      })
      .catch((err) => this.errorHandler(err));
  }

  clearControl() {
    this.data
  }

  errorHandler(err: any) {
    console.log(err);
    this.blockUI.stop();
  }

  getGUID() {
    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
      this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }

  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
}
